import { render, staticRenderFns } from "./AnalyzeBasicAskOpinion.vue?vue&type=template&id=4ca076f9&scoped=true&"
import script from "./AnalyzeBasicAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeBasicAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeBasicAskOpinion.vue?vue&type=style&index=0&id=4ca076f9&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeBasicAskOpinion.vue?vue&type=style&index=1&id=4ca076f9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca076f9",
  null
  
)

export default component.exports